
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor04Off as ObiBipolar_transistor04OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-04-off.js';
 
 
 

 
 export const ObiBipolar_transistor04Off = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-04-off',
   elementClass: ObiBipolar_transistor04OffElement,
   events: {
     
   }
  });
 
 